require('./brokerPensionPlanPeriodicalContributionView.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const BrokerPensionPlanPeriodicalContributionHeader = require('components/broker/brokerPensionPlanPeriodicalContribution/brokerPensionPlanPeriodicalContributionHeader/brokerPensionPlanPeriodicalContributionHeader');
const { BrokerPensionPlanPeriodicalContribution } = require('components/broker/brokerPensionPlanPeriodicalContribution/brokerPensionPlanPeriodicalContributionBody/brokerPensionPlanPeriodicalContribution');
const { EmptyState } = require('commonsComponents/emptyState');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKMessage } = require('commonsComponents/OKMessage');

// @actions
const BrokerPensionPlanPeriodicalContributionActions = require('actions/brokerPensionPlanPeriodicalContribution');

// @ constants
const { BROKER_MYPROFILE_MYWALLET_URL, PLANS_ACTIVE } = require('constants/index');
const WARNING_FISCAL_DATES = require('constants/brokerProviderWarningFiscalDates');

class BrokerPensionPlanPeriodicalContributionView extends React.Component {

    componentDidMount() {
        this.props.getPeriodicalContribution();
    }

    buildErrorState() {
        const goToMyWallet = formatText('broker-goToMyWallet');
        const emptyStateText = (
            <div className="pension-plan-periodical-contribution-view__error-text">
                <div>
                    {formatText('pensionPlanPeriodicalContribution-errorMessage1')}    
                </div>
                {formatText('pensionPlanPeriodicalContribution-errorMessage2')}
            </div>
        );
        return (
            <div className="pension-plan-periodical-contribution-view__error-state">
                <ContentBox>
                    <EmptyState 
                        secondaryText={emptyStateText}
                        linkText={goToMyWallet}
                        linkURL={BROKER_MYPROFILE_MYWALLET_URL}
                        iconType="nointernet-wealth" />
                </ContentBox>
            </div>
        );
    }

    getBodyContent() {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;
        const isServiceFail = immBrokerPensionPlanPeriodicalContribution.get('error');

        if (isServiceFail) {
            const errorState = this.buildErrorState();
            return errorState;
        } else {
            return (
                <BrokerPensionPlanPeriodicalContribution
                    immBrokerPensionPlanPeriodicalContribution={immBrokerPensionPlanPeriodicalContribution}
                />
            );
        }
    }

    buildFiscalWarning() {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;

        const today = new Date();
        const initialDate = WARNING_FISCAL_DATES.generalInitDate;
        const closeDate = WARNING_FISCAL_DATES.generalCloseDate;
        const activeContributionsList = immBrokerPensionPlanPeriodicalContribution.get('periodicalContributionList').find(
            value => {
                return value.getIn(['planAportacion','situacion']) === PLANS_ACTIVE;
            });

        if ((initialDate <= today) && (today <= closeDate) && (activeContributionsList)) {
            return (
                <div className="broker-search-results__disclaimer-personal-info">
                    <OKMessage type="informative" modifier="dark-bg">
                        <FormattedText value="brokerAttentionPlanStartingModal-fiscalDisclaimer" />
                        &nbsp;
                    </OKMessage>
                </div>
            );
        }

        return null;
    }

    render() {
        const { immBrokerPensionPlanPeriodicalContribution } = this.props;
        const hasPlanPeriodicalContribution = immBrokerPensionPlanPeriodicalContribution.get('hasPeriodicalPlans');
        const bodyContent = this.getBodyContent();
        return (
            <div className="pension-plan-periodical-contribution-view">
                <BrokerPensionPlanPeriodicalContributionHeader
                    hasPlans={hasPlanPeriodicalContribution}
                />
                <div className="pension-plan-periodical-contribution-view__body">
                    {this.buildFiscalWarning()}
                    {bodyContent}
                </div>
            </div>
        );
    }
}

BrokerPensionPlanPeriodicalContributionView.propTypes = {
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired,
    getPeriodicalContribution: PropTypes.func
};

module.exports.constructor = BrokerPensionPlanPeriodicalContributionView;
module.exports.BrokerPensionPlanPeriodicalContributionView = connect(
    state => ({
        immBrokerPensionPlanPeriodicalContribution: state.brokerPensionPlanPeriodicalContribution
    }),
    {
        getPeriodicalContribution: BrokerPensionPlanPeriodicalContributionActions.getPeriodicalContribution
    }
)(BrokerPensionPlanPeriodicalContributionView);
